var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagnifyingGlasscomponent = function SvgMagnifyingGlasscomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.194 8.75h.493l3.12 3.125-.932.931L8.75 9.688v-.494l-.169-.175a4.062 4.062 0 1 1 .438-.438l.175.169ZM3.125 5.937A2.809 2.809 0 0 0 5.938 8.75 2.809 2.809 0 0 0 8.75 5.937a2.809 2.809 0 0 0-2.813-2.812 2.809 2.809 0 0 0-2.812 2.813Z",
    fill: "current"
  })));
};
export default SvgMagnifyingGlasscomponent;